export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5598.988b3738.jpg";